import React from "react";
import Logo from "../components/Logo";
import Navigation from "../components/Navigation";

const About = () => {
  return (
    <div>
      <Logo />
      <Navigation />
      <h1>A propos</h1>
      <br />
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Ullam commodi
        non facere voluptate praesentium. Culpa voluptatibus esse ducimus animi
        ratione minus natus qui quod sapiente nesciunt dolorum in, iste
        assumenda atque, officia nobis id aspernatur veritatis ipsum. Delectus
        vero, provident aliquam adipisci sint, nisi totam ipsa et minima
        veritatis beatae. Similique pariatur, natus recusandae dolor quisquam
        optio ut consectetur qui incidunt beatae tempora eveniet unde tenetur
        voluptatum, voluptates officiis sed dolorem veniam! Laborum omnis
        doloremque illum dicta quaerat similique optio tempora maiores impedit
        quae ipsa at blanditiis officiis velit rerum, sapiente, dolorem, commodi
        aut atque! Quidem, error itaque. Repellat, itaque!
      </p>
      <br />
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Temporibus
        ipsum dolore molestiae architecto odit iure, dignissimos eum quod,
        nesciunt minima nostrum? Eligendi consectetur tempora corrupti natus,
        adipisci officiis quidem at aut beatae deleniti inventore dicta
        reiciendis commodi ad blanditiis ratione maiores autem suscipit
        consequuntur laborum dolorum nobis repellendus. Tenetur perferendis
        explicabo culpa perspiciatis distinctio dolores voluptates ea aut?
        Beatae aspernatur animi ad corporis provident incidunt dicta natus
        voluptatum, aperiam tempora nostrum molestias id doloribus et
        accusantium. Neque, vel quis cumque atque nesciunt at explicabo omnis
        eum saepe unde rem, similique libero laudantium voluptatum impedit nemo
        ipsum ea eius minus placeat.
      </p>
    </div>
  );
};

export default About;
